const { isEmpty } = _uo.utility;

/**
 * Search and returns the directory object of an integration
 *
 * @param {String} integrationCode The integration code
 * @return {Object} The integration
 */
const getIntegration = ( integrationCode ) => {
	if ( isEmpty( integrationCode ) ) {
		throw new Error( `getIntegration: integrationCode must be defined` );
	}

	return UncannyAutomator._integrations[ integrationCode ];
}

export default getIntegration;
